/* Core & libraries */
import * as React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../../buttons/index.js";
import { colors } from "../../../constants/colors.js";

/* Styles */
import styles from "./styles.js"


const Footer = props => {
  const { setShowModal, handleSaveModal, settingsLocked, sameSettingsSelected } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.btnContainer}>
      <ContainerFluid>
        <Row className={classes.btnsRow}>
          <Col className={classes.colCancel}>
            <UCButton
              onClick={() => setShowModal(false)}
              type="default"
              className={classes.cancelBtn}
              text={<FormattedMessage id="tripCredits.settings.modal.cancel" />}
            />
          </Col>
          <Col className={classes.colRemove}>
            <UCButton
              className={classes.confirmBtn}
              onClick={handleSaveModal}
              type="primary"
              text={<FormattedMessage id="tripCredits.settings.modal.confirm" />}
              disabled={settingsLocked || sameSettingsSelected}
            />
          </Col>
        </Row>
      </ContainerFluid>
    </div>
  )
}

export default Footer;